import { APITransport } from '@client/transports/api';

export const SignaturesService = {
  async getAll() {
    const response = await APITransport.get({
      path: '/rest/domain/signatures'
    });

    return Array.isArray(response) ? response : [];
  },
  getSignature(body = {}, options = {}) {
    return APITransport.post({
      path: '/rest/domain/execute/rendersig',
      body: {
        ...body,
        preview: true
      },
      ...options
    });
  },
  generatePlainTextSignature(body) {
    return APITransport.post({
      path: '/rest/domain/execute/generatesigblock',
      body
    });
  },
  getDefaultSignatures(username, alias, type) {
    return APITransport.post({
      path: `/rest/domain/execute/${type}getsig`,
      body: {
        username,
        alias
      }
    });
  },
  updateDefaultSignatures(username, alias, type, newSig) {
    return APITransport.post({
      path: `/rest/domain/execute/${type}updatesig`,
      body: {
        username,
        newSig,
        alias
      }
    });
  }
};
